import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar } from '../../../../global/commonStyle';
const Group = styled.div`
  background-color: var(--background-secondary);
  box-orient: vertical;
  flex-direction: column;
  display: flex;
`;
const HeaderBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  margin-block: var(--space-14) var(--space-24);
`;

const Icon = styled.div`
  display: inline-flex;
`;

const HeaderTitle = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Group1 = styled.div`
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  overflow: hidden;
  ${mobile_xl(css`
    ${HideScrollbar}
  `)}
`;
const MainGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding-bottom: var(--space-10);
  ${mobile_xl(css`
    padding-block: var(--space-8) var(--space-96);
  `)}
`;

const Quantity = styled.p`
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  white-space: nowrap;
  padding-left: var(--space-12);
  border-left: 0.5px solid var(--border-primary);
  margin: var(--space-0);
  text-align: right;
`;

const Label = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Price = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  border-left: 0.5px solid var(--border-primary);
  padding-left: var(--space-12);
  margin: var(--space-0);
  text-transform: uppercase;
  white-space: nowrap;
`;

const Check = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  white-space: nowrap;
`;
const Text = styled.p`
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const Group2 = styled.h1`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  margin: var(--space-0);
`;
const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Desc = styled.div`
  padding: var(--space-12);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  gap: var(--space-20);
  display: flex;
  flex-direction: column;
`;
const BillingTime = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;
const BillingHour = styled.p`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const LeftBilling = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  .radio-Button {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }
`;

const Buttons = styled.div`
  display: flex;
  align-items: flex-start;
  padding: var(--space-0);
  gap: var(--space-10);
`;

const FormView = styled.div`
  position: relative;
  z-index: var(--z-index-toast);
  ${mobile_xl(css`
    padding-left: var(--space-24);
  `)}
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;
const TimeEntry = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;
const TimeDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: var(--background-primary);
  thead tr {
    background-color: var(--background-tertiary);
    border-bottom: 0.5px solid var(--border-primary) !important;
    td {
      :last-child {
        padding-left: var(--space-0);
      }
    }
  }
  tr {
    border-bottom: 0.5px solid var(--border-primary);
    :last-child {
      border-bottom: none;
    }
  }
`;

const TableRow = styled.tr``;

const TableCell = styled.td`
  padding: var(--space-10) var(--space-12);
  ${Typography.body_md_medium}
  color: var(--text-primary);
  white-space: nowrap;
  :nth-child(2) {
    text-align: right;
  }
  ${mobile_xl(css`
    :nth-child(2) {
      text-align: left;
      padding-left: var(--space-24);
    }
  `)}
`;
const TableHeaderCell = styled.td`
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  padding: var(--space-10) var(--space-12);
`;
const DropdownDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-5);
  `)}
`;

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
`;

const BillableHoursWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
`;

export {
  Group,
  HeaderBlock,
  Icon,
  HeaderTitle,
  Group1,
  MainGroup,
  Quantity,
  Price,
  Label,
  Text,
  Check,
  Title,
  Group2,
  Desc,
  BillingTime,
  BillingHour,
  LeftBilling,
  Buttons,
  FormView,
  TimeEntry,
  TimeDetail,
  StyledTable,
  TableCell,
  TableRow,
  TableHeaderCell,
  DropdownDiv,
  RadioWrapper,
  BillableHoursWrapper
};
